import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { navigate } from "gatsby";

import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuIcon from '@material-ui/icons/Menu';
import Hidden from '@material-ui/core/Hidden';

import { useAuth } from "../contexts/AuthContext"

import Link from "./Link"
import theLayoutStyles from "./layoutStyles";
import TheDrawer from "./drawer";


export default function TheAppBar(props) {
    const data = useStaticQuery(graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `)

    const { currentUser, logout } = useAuth();
    
    const [menuState, setMenuState] = React.useState(false);
    const handleDrawerToggle = () => {
        setMenuState(!menuState);
      };
    
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };

    const [error, setError] = React.useState("")
    async function handleLogout() {
        setError("")

        try {
            await logout()
        } catch {
        setError("Failed to log out")
        }
    }
  
    const classes = theLayoutStyles();
  
    return (
        <div>
        <AppBar position="fixed" className={classes.appBar}>
            <Toolbar>
                <Hidden smUp implementation="js">
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                </Hidden>
                <Typography variant="h5" noWrap className={classes.title}>
                    <Link to="/" style={{
                            color: `white`,
                            textDecoration: `none`,
                        }}>
                        {data.site.siteMetadata.title}
                    </Link>
                </Typography>
                <Hidden xsDown implementation="js">

                    <Typography variant="body1" noWrap className={classes.subtitle}>
                        <Link to="/about" style={{
                                color: `white`,
                                textDecoration: `none`,
                            }}>
                            About us
                        </Link>
                    </Typography>
                </Hidden>
            {(
            <div>
                {currentUser ?
                    <React.Fragment>
                    <Typography variant="body1" display="inline">Hi, </Typography>
                    <Typography variant="body1" style={{ fontWeight: 500 }} display="inline">
                        {currentUser.displayName}!
                    </Typography>
                    </React.Fragment>
                : null
                }
                <IconButton
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={(event) => handleMenu(event)}
                    color="inherit"
                >
                    <AccountCircle style={{ fontSize: 32}} />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    open={open}
                    onClose={handleClose}
                >
                {currentUser ?
                    [
                        <MenuItem key="dashboard" onClick={()=>{
                            handleClose();
                            navigate("/app/dashboard/");
                        }}>Dashboard</MenuItem>,
                        <MenuItem key="Logout" onClick={(event)=>{
                                handleClose();
                                handleLogout();
                                navigate("/");
                                }
                            }>Logout</MenuItem>
                    ]
                : 
                    [
                        <MenuItem key="login" onClick={()=>{
                                handleClose();
                                navigate("/app/login");
                                // "/login/" is generated at runtime. "/dashboard/" exists at buildtime
                                // and redirects to "/login/" at runtime.
                                }
                            }
                        >Login</MenuItem>,
                    ]
                }
                </Menu>
            </div>
            )}
            </Toolbar>
        </AppBar>
        <TheDrawer menuState={menuState} setMenuState={setMenuState} />
      </div>
      );
}